import React from 'react'

export const Nav = ({children}: any) => {
    return <div style={{ position: 'fixed', bottom: 16, zIndex: 11, width: '100%', flexDirection: 'row', display: 'flex', justifyContent: 'center', paddingLeft: 10, paddingRight: 10 }}>{children}</div>
}